import React, { useEffect, useState } from "react";
import { Title } from "../../../../stories/Title/Title";
import Close from "../../../../images/Close.svg";
import { TextField } from "@mui/material";
import { Label } from "../../../../stories/Label/Label";
import Input from "../../../../stories/Input/Input";
import TextArea from "../../../../stories/TextArea/TextArea";
import { StyledDatagrid } from "../../../../styles/DatagridStyles";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import { TableHeaderProps } from "../../../../utils/types";
import useAssetTableJson from "../../../../json/useAssetTableJson";
import { ColumnVisibilityFor } from "../../../../utils/Enum.Datagrid";
import { TABLE_ROW_HEIGHT } from "../../../../styles/Variables";
import { TableHeaders } from "../../../../utils/Enum.types";
import { Button } from "../../../../stories/Button/Button";
import useLabels from "../../../../customHooks/useLabels";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const ViewPurchaseItem = ({ setModalFlag }: Props) => {
  const { Purchase } = useAssetTableJson();
  const dynamicHeaders: TableHeaderProps[] = Purchase.Add.filter((header)=>header.headerName !== TableHeaders.ACTION).map((header) => {
    return {
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      cellClassName: header.cellClassName,
      hideable: header.hideable
    };
  });
  const columns: GridColDef[] = [...dynamicHeaders];
  const rowData: GridValidRowModel[] = [
    {
      id: 1,
      item_code: "",
      hsn_code: "",
      uom: "",
      rate: "",
      qty: "",
      per_disc_perc: 0,
      prm_disc_amt: 0,

      taxable_rate: 0,
      taxable_value: 0,
      igst: 0,
      sgst: 0,
      cgst: 0,
      tax_amount: 0,
      delivery_charges: 0,
      installation_charges: 0,
      net_value: 0,
      action: 0
    }
  ];

  const getRow = () => {
    if (rowData.length) {
      return [
        {
          id: [],
          item_code: [],
          hsn_code: [],
          uom: [],
          rate: "Total",
          qty: 0,
          per_disc_perc: [],
          prm_disc_amt: [],
          taxable_rate: 0,
          taxable_value: 0,
          igst: [],
          sgst: [],
          cgst: [],
          tax_amount: 0,
          delivery_charges: [],
          installation_charges: [],
          net_value: 0,
          actions: []
        }
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow()
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "net_value":
        case "taxable_rate":
        case "taxable_value":
          return "total-count";
        case "rate":
          return "total";
        case "tax_amount":
          return "balance-count";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.PURCHASE_ENTRY_VIEW
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.PURCHASE_ENTRY_VIEW,
      JSON.stringify(newModel)
    );
  };
  const {itemLabel,ledgerLabel}=useLabels();
  return (
    <>
      <div className="view-purchase-item">
        <div className="view-purchase-item__title">
          <Title>View Purchase {itemLabel}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        <div className="purchase__add--filterblock row g-0">
          <div className="col">
            <TextField
              disabled
              value="Praveen"
              label={`${ledgerLabel} Name.`}
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <div className="purchase__add--filterblock--flex">
              <TextField
                disabled
                value="6899"
                label="GST No."
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                className="purchase__add--filterblock--textfield"
              />{" "}
              <TextField
                disabled
                value="6899"
                label="Mobile No."
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                className="purchase__add--filterblock--textfield"
              />
            </div>
            <TextField
              disabled
              value="6899"
              label="Adress"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
          </div>
          <div className="col">
            <TextField
              disabled
              value="6899"
              label="Last Purchased"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              disabled
              value="6899"
              label="Purchased Date"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              disabled
              value="6899"
              label="Balance"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield font-red"
            />
          </div>
          <div className="col">
            <TextField
              disabled
              value="6899"
              label="Last Purchase Order No."
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              disabled
              value="6899"
              label="Last Purchased Date"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield--date"
            />
          </div>
          <div className="col">
            
            <TextField
            disabled
              label="Invoice No."
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
            disabled
              label="purchase Type"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <div className="purchase__add--filterblock--flex">
              <TextField
              disabled
                label="Entry Bill"
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                className="purchase__add--filterblock--textfield"
              />
              <TextField
              disabled
                label="Type of Bill"
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                className="purchase__add--filterblock--textfield"
              />
            </div>
          </div>
          <div className="col">
            <TextField
              label="Invoice Date"
              disabled
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield--date"
            />
            <TextField
            disabled
              label="Courier"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
            disabled
              label="Courier No."
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
          </div>
        </div>
        <div className="purchase__add--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rowData}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel
              }
            }}
            hideFooter
            pinnedRows={pinnedRows}
            getCellClassName={getCellClassName}
          />
        </div>
        <div className="purchase__add--datablock">
          <div className="purchase__add--datablock--left">
            <div className="label-grid">
              <Label>Entered By</Label>
              <Input disabled />
              <Label>Narration</Label>
              <TextArea rows={4} disabled />
            </div>
          </div>
          <div className="purchase__add--datablock--right">
            <div className="purchase__add--datablock--right--flex">
              <Label>Total Delivery Charges :</Label>
              <Input disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Total Installation Charges :</Label>
              <Input disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Secondary Discount Amount :</Label>
              <Input className="font-red" disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Freight / Extra Charges :</Label>
              <Input className="font-amber" disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Net Amount :</Label>
              <Input className="total-count" disabled value="0" />
            </div>
          </div>
        </div>
        <Button mode="cancel" onClick={()=>setModalFlag(false)}/>
      </div>
    </>
  );
};

export default ViewPurchaseItem;
